import type { Widget, WidgetDefinitionNew } from '@neptune/shared/widgets-domain';

import { TimeScale } from 'domain/common/time-scale';
import { WidgetDefinition } from 'domain/widget/core/domain/widget-definition';

export type ValueListWidget = Widget & {
  type: 'valueList';
  options: ValueListWidgetOptions;
};
export type ValueListWidgetOptions = {
  timeScale: TimeScale;
  showIndex: boolean;
};

export function isValueListWidget(widget: Widget): widget is ValueListWidget {
  return widget.type === 'valueList';
}

function valueListWidgetOptionsFromApiToDomain(options?: Record<string, any>) {
  return {
    timeScale: options?.timeScale,
    showIndex: options?.showIndex,
  };
}

export const valueListWidgetDefinitionNew: WidgetDefinitionNew = {
  widgetType: 'valueList' as const,
  label: 'Logs',
  description: 'Display string series',
  icon: 'list',
  dataItem: 'valueList',
  hasSettings: true,
};

export const valueListWidgetDefinition: WidgetDefinition = {
  type: 'valueList',
  fromApiToDomain: valueListWidgetOptionsFromApiToDomain,
};

export const DEFAULT_VALUE_LIST_CONFIG: ValueListWidgetOptions = {
  timeScale: 'absoluteTime',
  showIndex: false,
};
